import React from 'react';
import { useHistory } from 'react-router-dom';
import App from '@app';
import { Body, PageHeader, AddButton } from '@components';
import TableGrupos from './TableGrupos';

export default function TemplateGrupos() {
  const history = useHistory();

  return (
    <App>
      <Body>
        <PageHeader
          title='Grupo de Templates'
          extra={[
            <AddButton
              key='1'
              type='primary'
              tooltipTitle='Adicionar Grupo'
              style={{ marginBottom: 10 + 'px', borderRadius: 5 + 'px' }}
              onClick={() => history.push('/conectores/templates/grupo/cadastro/-1')}
            />,
          ]}
        >
          <TableGrupos />
        </PageHeader>
      </Body>
    </App>
  );
}
